import { ICreateMaquinasEquipItensUseCase } from "../../../presentation/useCases/create/create_maquinas_equip_itens_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * CreateMaquinasEquipItensUseCase
 */

export class CreateMaquinasEquipItensUseCase implements ICreateMaquinasEquipItensUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async createMaquinasEquipItens(
    idMaquinaEquip: number,
    ordem: string,
    descricao: string,
  ): Promise<number> {
    return await this.repository.createControledePatrimonioMaquinasEquipItens(
      idMaquinaEquip,
      ordem,
      descricao,
    );
  }
}
